async function initialize(root) {
  if (root.dataset.initialized) return;
  let core;
  try { core = await import(root.dataset.coreUrl); }
  catch { return; } // The visible loading explanation and disabled controls remain.
  const { validateSignup, buildSubscription, sendSubscription, errorMessage } = core;
  root.dataset.initialized = 'true';
  const config = { companyId: root.dataset.companyId, emailList: root.dataset.emailList, whatsappList: root.dataset.whatsappList };
  const identity = {};
  const accepted = new Set();
  const dialog = root.querySelector('dialog');
  const states = new Map();
  let origin;
  // Serialize overlapping submits so the second payload can use the first accepted identifier.
  let queue = Promise.resolve();
  const forms = [...root.querySelectorAll('[data-signup-form]')];
  const unavailable = root.querySelector('[data-unavailable]');
  unavailable.hidden = true;

  function acknowledge(button) {
    origin = button;
    const channel = accepted.has('email') && accepted.has('whatsapp') ? 'e-mail en WhatsApp' : accepted.has('email') ? 'e-mail' : 'WhatsApp';
    dialog.querySelector('[data-dialog-message]').textContent = `We hebben je aanvraag voor lanceringsnieuws via ${channel} ontvangen. Je gegevens worden verwerkt.`;
    if (!dialog.open) dialog.showModal();
  }
  dialog.querySelector('[data-dialog-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => origin?.focus({ preventScroll: true }));
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const focusables = [...dialog.querySelectorAll('button, a[href]')];
    const first = focusables[0], last = focusables.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  for (const form of forms) {
    const channel = form.dataset.channel;
    const input = form.elements.contact;
    const consent = form.elements.consent;
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-status]');
    const idleLabel = button.textContent;
    states.set(channel, 'idle');
    button.disabled = false;
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (states.get(channel) === 'submitting') return;
      if (accepted.has(channel)) { acknowledge(button); return; }
      input.removeAttribute('aria-invalid');
      consent.removeAttribute('aria-invalid');
      status.textContent = '';
      let identifier;
      try {
        identifier = validateSignup(channel, input.value, consent.checked);
      } catch (error) {
        states.set(channel, 'invalid');
        form.dataset.state = 'invalid';
        status.textContent = errorMessage(error.code);
        const invalid = error.field === 'consent' ? consent : input;
        invalid.setAttribute('aria-invalid', 'true');
        invalid.focus();
        return;
      }
      states.set(channel, 'submitting');
      form.dataset.state = 'submitting';
      form.setAttribute('aria-busy', 'true');
      button.disabled = true;
      input.readOnly = true;
      consent.disabled = true;
      button.textContent = 'Bezig met aanmelden…';
      queue = queue.then(async () => {
        try {
          const payload = buildSubscription({ channel, identifier, consent: true, identity, config });
          await sendSubscription(payload, config.companyId);
          accepted.add(channel);
          identity[channel === 'email' ? 'email' : 'phone_number'] = identifier;
          states.set(channel, 'accepted');
          form.dataset.state = 'accepted';
          status.textContent = 'Je aanmelding is ontvangen.';
          button.textContent = 'Aanmelding ontvangen ✓';
          for (const other of forms) {
            if (!accepted.has(other.dataset.channel)) {
              const hint = other.querySelector('[data-identity-hint]');
              hint.hidden = false;
              hint.textContent = 'Dit kanaal wordt toegevoegd aan dezelfde aanmelding.';
            }
          }
          acknowledge(button);
        } catch (error) {
          states.set(channel, 'error');
          form.dataset.state = 'error';
          status.textContent = errorMessage(error.code);
          button.textContent = idleLabel;
        } finally {
          button.disabled = false;
          input.readOnly = accepted.has(channel);
          consent.disabled = accepted.has(channel);
          form.removeAttribute('aria-busy');
        }
      });
    });
  }
}

document.querySelectorAll('[data-monique-prelaunch]').forEach(initialize);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-monique-prelaunch]').forEach(initialize));
document.querySelectorAll('a[href="#monique-signup"]').forEach(link => link.addEventListener('click', () => {
  document.getElementById('monique-signup')?.focus({ preventScroll: true });
}));
